﻿(function () 
{
    var dealslider;

    function initSlider() 
    {
        var dealcontainer = document.querySelector('.deal-card-carousel');

        if (window.innerWidth > 767.98) 
        {
            if (dealcontainer && !dealslider) 
            {
                dealslider = tns({
                    container: '.deal-card-carousel',
                    loop: false,
                    autoplay: false,
                    nav: false,
                    lazyload: true,
                    useLocalStorage: false,
                    controlsContainer: ".deal-card-controls",

                    responsive: {
                        768: {
                            fixedWidth: 340,
                            mouseDrag: true,
                            gutter: 0,
                            swipeAngle: false,
                            slideBy: "page",
                            controls: true,
                            speed: 400,
                            axis: "horizontal"
                        }
                    },
                    onInit: function () 
                    {
                        dealcontainer.classList.add("init");
                    }
                });
            }
        }
        else 
        {
            if (dealslider) 
            {
                dealslider.destroy(); // Destroy slider when under 768px
                dealslider = null;
            }
        }
    }

    function waitForComponentReady() 
    {
        var checkExist = setInterval(function () 
        {
            if (document.querySelector('.deal-card-wrap-outer')) 
            {
                clearInterval(checkExist);
                initSlider();
            }
        }, 100); // check every 100ms
    }

    waitForComponentReady();
    window.addEventListener('resize', initSlider);

})();
